import { createAsyncThunk } from '@reduxjs/toolkit'
import DataService from "../service";
import { constant } from '../constant'
const { path } = constant;
export const fetchWorkForceList = createAsyncThunk(
    'workForce/fetchWorkForce',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+'client/report/v1/workforce/list', rejectWithValue)
)

export const fetchCurrentWorkForceList = createAsyncThunk(
    'workForce/fetchCurrentWorkForce',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+'client/report/v1/latest-workforce', rejectWithValue)
)

export const createUpdateWorkForce = createAsyncThunk(
    'workForce/createUpdateWorkForce',
    (arg, { rejectWithValue }) => DataService.post(arg, path+'/client/report/v1/workforce', rejectWithValue)
)

export const deleteWorkForce = createAsyncThunk(
    'wards/deleteWorkForce',
    (arg, { rejectWithValue }) => DataService.delete(arg, path+`/client/report/v1/workforce/delete/${arg?.wardId}`, rejectWithValue)
)
